import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const NotificationApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addNotification: builder.mutation<CommonResponseType, any>({
      query: (body) => ({
        url: END_POINTS.notification,
        method: "POST",
        body,
      }),
    }),
    getNotification: builder.query<
      CommonResponseType & {
        data: {
          data: any[];
          total: number;
        };
      },
      {
        from: number;
        size: number;
        search: string;
      }
    >({
      query: ({ from, size, search }) => ({
        url:
          `${END_POINTS.notification}?from=${from}&size=${size}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getNotificationDetail: builder.query<
      CommonResponseType & {
        data: any;
      },
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.notification}/${id}`,
        method: "GET",
      }),
    }),
    updateNotification: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.notification}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteNotification: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.notification}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetNotificationQuery,
  useLazyGetNotificationDetailQuery,
  useAddNotificationMutation,
  useUpdateNotificationMutation,
  useDeleteNotificationMutation
} = NotificationApi;
